import {DependencyList, useEffect, useRef, useState} from 'react';

const useElementWidth = <T extends HTMLElement>(enabled: boolean, deps: DependencyList = []) => {
    const ref = useRef<T>(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (!enabled || !ref.current) {
            return;
        }

        const element = ref.current;
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setWidth(entry.contentRect.width);
            }
        });

        resizeObserver.observe(element);
        setWidth(element.offsetWidth);

        return () => {
            resizeObserver.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, ...deps]);

    return { ref, width };
};

export default useElementWidth;
